export default __webpack_public_path__ + "static/media/propulsionlab.272f4fa3.png";